


































import { Component, Vue, Prop } from "vue-property-decorator";
import { primaryTitle, tertiaryBody } from "@/helpers/styleClassHelpers";
import CustomButton from "./Button.vue";
import GuideBalloon from "./GuideBalloon.vue";
import { showSuccessAlert } from "@/helpers";

@Component({
	components: {
		"custom-button": CustomButton,
		GuideBalloon,
	},
})
export default class RatingValueStar extends Vue {
	@Prop({ default: () => ({}) }) appointment!: any;

	primaryTitle = primaryTitle;
	tertiaryBody = tertiaryBody;

	stars = 1;

	get solutionName() {
		return this.appointment.solution?.name;
	}

	get solutionCategoryName() {
		return this.appointment.solution?.category?.name;
	}

	setStars(number: number) {
		this.stars = number;
	}

	saveRating() {
		this.$emit("saveAction", "approved", this.stars, this.appointment);
	}

	copyText() {
		navigator.clipboard.writeText(
			`Gostaria de saber se você gostou do atendimento, poderia dar uma nota de 1 a 5 para ${this.solutionCategoryName} (${this.solutionName})`,
		);
		showSuccessAlert("", "Texto copiado");
	}
}
